<footer class="layout-footer">
  <nav aria-label="Informazioni legali">
    <ul class="layout-footer__links">
      <li>
        <a [routerLink]="accessibilityRoute">Dichiarazione di accessibilità</a>
      </li>
    </ul>
  </nav>
  <span class="layout-footer__copyright">&copy; {{ currentYear }} Novatellus</span>
</footer>
